import { Button } from '@/components/ui/button';
import { type ReactNode } from 'react';

interface PageFiltersMenuProps {
  title?: string;
  activeCount?: number;
  onClear?: () => void;
  clearLabel?: string;
  children: ReactNode;
}

export const PageFiltersMenu = ({
  title = 'Filters',
  activeCount = 0,
  onClear,
  clearLabel = 'Clear all',
  children,
}: PageFiltersMenuProps) => {
  return (
    <div className='space-y-3 px-1 py-1'>
      <div className='flex items-center justify-between'>
        <h4 className='text-sm font-medium'>{title}</h4>
        {activeCount > 0 && onClear && (
          <Button variant='ghost' size='sm' onClick={onClear} className='h-auto p-0 text-xs'>
            {clearLabel}
          </Button>
        )}
      </div>
      {children}
    </div>
  );
};
